import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modal', 'content']

  open(event) {
    event.preventDefault()
    const dailyId = event.params.id
    fetch('/hours/disapprove/' + dailyId, {
      headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.text())
      .then(html => {
        this.contentTarget.innerHTML = html
        this.modalTarget.style.display = 'block'
      })
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.style.display = 'none'
  }
}
